import { GoalType, OWN, PENALTY } from '../../../typings/match-formations';
import { FIRSTHALF, SECONDHALF, EXTRAFIRSTHALF, EXTRASECONDHALF } from '../../../typings/match';
import t from '../../../labels/labelling-utils';
import { groupBy } from '../../../utils/array';
import { safeUpperCase } from '../../../utils/string-utils';

import { IScoreboard } from './team';

const getGoalType = (goal: GoalType): string => {
  switch (goal) {
    case OWN:
      return `(${t('match.player.autoGoal')})`;

    case PENALTY:
      return `(${t('match.player.penalty')})`;

    default:
      return '';
  }
};

export const formatScoreboardMinute = (scoreboard: IScoreboard): string => {
  const FIRST_HALF_MINUTES = 45;
  const SECOND_HALF_MINUTES = 90;
  const EXTRA_FIRST_HALF_MINUTES = 105;
  const EXTRA_SECOND_HALF_MINUTES = 120;

  const matchStatusMap = {
    [FIRSTHALF]: FIRST_HALF_MINUTES,
    [SECONDHALF]: SECOND_HALF_MINUTES,
    [EXTRAFIRSTHALF]: EXTRA_FIRST_HALF_MINUTES,
    [EXTRASECONDHALF]: EXTRA_SECOND_HALF_MINUTES,
  };

  const { minute, matchStatus } = scoreboard;
  const numericMinute = Number(minute);

  if (
    !matchStatus ||
    !matchStatusMap[matchStatus] ||
    Number.isNaN(numericMinute) ||
    numericMinute <= matchStatusMap[matchStatus]
  ) {
    return `${minute}'`;
  }

  return `${matchStatusMap[matchStatus]}' + ${numericMinute - matchStatusMap[matchStatus]}'`;
};

// Convert SCOREBOARD Array of OBJECTS to Array of STRINGS grouped by PLAYER
export const getScoreboard = (scoreboard: IScoreboard[], key: string, value: string): string[] => {
  const groupedScoreboard: [string, IScoreboard[]][] = Array.from(groupBy(scoreboard, key));
  return groupedScoreboard.map((item: [string, IScoreboard[]]) => {
    const goals = item[1].map((score: IScoreboard) => {
      const gType = score.type && getGoalType(safeUpperCase(score.type) as GoalType);
      const formattedMinute = formatScoreboardMinute(score);
      return gType ? `${formattedMinute} ${gType}` : `${formattedMinute}`;
    });

    return `${item[0]} ${goals.join(', ')}`;
  });
};
